import { render, staticRenderFns } from "./VircosMeasuresSheet.vue?vue&type=template&id=cb2df1c8&scoped=true&"
import script from "./VircosMeasuresSheet.vue?vue&type=script&lang=js&"
export * from "./VircosMeasuresSheet.vue?vue&type=script&lang=js&"
import style0 from "./VircosMeasuresSheet.vue?vue&type=style&index=0&id=cb2df1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2df1c8",
  null
  
)

export default component.exports